function saveConfiguration() {
    return expivi.saveConfiguration(512, 512);
}

// Delay helper
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// NEW FUNCTION: send configuration + SKU to Make.com
function sendConfigToMakeWebhook(configurationSku, config) {
    const payload = JSON.stringify({
        configurationSku: configurationSku,
        configuration: config
    });

    return fetch("https://hook.eu2.make.com/8g9cyixl77ddezae6c20d71ru0pemd9c", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: payload
    })
    .then(function(response) {
        if (!response.ok) {
            throw new Error(`Webhook error: ${response.status}`);
        }

        console.log("[XPV] Config + SKU sent to Make.com successfully.");
    })
    .catch(function(error) {
        console.error("[XPV] Failed to send config to Make.com:", error);
        throw error;
    });
}

function createVariant(savedBundle) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: 'POST',
            url: '/apps/configurator',
            data: JSON.stringify({
                configuration: savedBundle.configured_products,
                productId: shopifyProductId
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(function(createResult) {
            createResult.configuredProduct = savedBundle.configured_products[0];
            resolve(createResult);
        }).fail(reject);
    });
}

function addToCart(createResult) {
    return new Promise(function (resolve, reject) {
        let addJsResponse = {
            quantity: 1,
            id: createResult.variant_id,
            properties: createResult.options,
        };

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify(addJsResponse),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(resolve).fail(reject);
    });
}

window.xpv_hooks_add_to_cart = function(context, event) {
    $button = $(context);
    shopifyProductId = $button.data('productId');

    if ($button[0].hasAttribute('disabled')) {
        return false;
    }

    event.preventDefault();
    $button.attr('disabled', 'disabled');
    $button.addClass('loading');

    let savedConfig; // Store saveConfiguration result

    return Promise.resolve()
        .then(function () {
            return saveConfiguration();
        })
        .then(function (result) {
            savedConfig = result; // Save for later
            return delay(200).then(() => createVariant(result));
        })
        .then(function (createResult) {
            return delay(200).then(() => {
                const configurationSku = createResult.options["Configuration SKU"];
                return sendConfigToMakeWebhook(configurationSku, savedConfig).then(() => createResult);
            });
        })
        .then(function (result) {
            return delay(200).then(() => {
                return addToCart(result);
            });
        })
        .then(function () {
            if ($button.data('url') !== 'NONE') {
                window.location.href = $button.data('url');
            }
            return false;
        })
        .catch(function (error) {
            $button.removeAttr('disabled');
            $button.removeClass('loading');
            console.error("[XPV] Add to cart flow failed:", error);
            throw error;
        });
};
